export default state => `
<h1>${state.title}</h1>
Lorem Ipsum`;
